export default __webpack_public_path__ + "static/media/seven-sisters.fd0106ba.jpg";